// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Projects_projectsContainer__-R2MS {
  padding: 2rem;
  width: 100%;
  box-sizing: border-box;
}

.Projects_header__dI0Cs {
    font-size: 6vw;
    margin: 1% 0 2rem 0;
    font-family: "Quantify", sans-serif;
    line-height: 1.7;
    font-stretch: 110%;
    font-weight: 180;
    color: var(--title-color);
    text-align: center;
}

.Projects_projectsGrid__yRVVC {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
  padding: 0 5%;
}

.Projects_projectCard__jYQ1I {
  background-color: var(--bg-color, black);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px var(--shadow-color, rgba(0, 0, 0, 0.1));
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 3px solid var(--frame-color, #eee);
  display: flex;
  flex-direction: column;
  width: 100%;
}

.Projects_projectCard__jYQ1I:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 16px var(--shadow-color, rgba(0, 0, 0, 0.2));
}

.Projects_imageContainer__e6hL2 {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.Projects_projectImage__3Qnle {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.Projects_projectCard__jYQ1I:hover .Projects_projectImage__3Qnle {
  transform: scale(1.05);
}

.Projects_projectTitle__04slj {
  padding: 1.25rem;
  text-align: center;
  margin: 0;
  font-family: "Astonpoliz", sans-serif;
  color: var(--text-color, #333);
  background-color: var(--bg-color, #fff);
  flex-grow: 1;
}
.Projects_subheader__bMjy0 {
    font-size: 3vw;
    margin: 1% 0 2rem 0;
    font-family: "Quantify", sans-serif;
    line-height: 1.7;
    font-stretch: 110%;
    color: var(--hover-color);
}
/* ---------------------- For mobile ---------------------------- */
@media (max-width: 768px) {
  .Projects_projectsGrid__yRVVC {
    grid-template-columns: 1fr;
    justify-items: stretch;
    padding: 0;
    margin: 2rem 0 0 0;
    /*gap: 1.5rem;*/
    width: 100%;
  }

  .Projects_projectCard__jYQ1I {
    max-width: none;
    width: 100%;
    margin: 0;
  }

  .Projects_subheader__bMjy0 {
    font-size: 6vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Projects.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6D;EAC7D,eAAe;EACf,qDAAqD;EACrD,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,8DAA8D;AAChE;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,qCAAqC;EACrC,8BAA8B;EAC9B,uCAAuC;EACvC,YAAY;AACd;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA,mEAAmE;AACnE;EACE;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".projectsContainer {\n  padding: 2rem;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.header {\n    font-size: 6vw;\n    margin: 1% 0 2rem 0;\n    font-family: \"Quantify\", sans-serif;\n    line-height: 1.7;\n    font-stretch: 110%;\n    font-weight: 180;\n    color: var(--title-color);\n    text-align: center;\n}\n\n.projectsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-top: 2rem;\n  padding: 0 5%;\n}\n\n.projectCard {\n  background-color: var(--bg-color, black);\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px var(--shadow-color, rgba(0, 0, 0, 0.1));\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 3px solid var(--frame-color, #eee);\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.projectCard:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 8px 16px var(--shadow-color, rgba(0, 0, 0, 0.2));\n}\n\n.imageContainer {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n}\n\n.projectImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.projectCard:hover .projectImage {\n  transform: scale(1.05);\n}\n\n.projectTitle {\n  padding: 1.25rem;\n  text-align: center;\n  margin: 0;\n  font-family: \"Astonpoliz\", sans-serif;\n  color: var(--text-color, #333);\n  background-color: var(--bg-color, #fff);\n  flex-grow: 1;\n}\n.subheader {\n    font-size: 3vw;\n    margin: 1% 0 2rem 0;\n    font-family: \"Quantify\", sans-serif;\n    line-height: 1.7;\n    font-stretch: 110%;\n    color: var(--hover-color);\n}\n/* ---------------------- For mobile ---------------------------- */\n@media (max-width: 768px) {\n  .projectsGrid {\n    grid-template-columns: 1fr;\n    justify-items: stretch;\n    padding: 0;\n    margin: 2rem 0 0 0;\n    /*gap: 1.5rem;*/\n    width: 100%;\n  }\n\n  .projectCard {\n    max-width: none;\n    width: 100%;\n    margin: 0;\n  }\n\n  .subheader {\n    font-size: 6vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"projectsContainer": `Projects_projectsContainer__-R2MS`,
	"header": `Projects_header__dI0Cs`,
	"projectsGrid": `Projects_projectsGrid__yRVVC`,
	"projectCard": `Projects_projectCard__jYQ1I`,
	"imageContainer": `Projects_imageContainer__e6hL2`,
	"projectImage": `Projects_projectImage__3Qnle`,
	"projectTitle": `Projects_projectTitle__04slj`,
	"subheader": `Projects_subheader__bMjy0`
};
export default ___CSS_LOADER_EXPORT___;
